// import * as React from "react";

// const Image = ({ className, forceAspectRatio, ...props }) => {
//     const cssBaseClass = "image";

//     const classList = [cssBaseClass];
//     let heightPercentage = "auto";

//     // if (
//     //     props.image &&
//     //     props.image.width &&
//     //     props.image.height &&
//     //     !forceAspectRatio
//     // ) {
//     //     classList.push(`${cssBaseClass}--force-aspect-ratio`);
//     //     if (props.image)
//     //         heightPercentage = `${
//     //             (props.image.height / props.image.width) * 100
//     //         }%`;
//     // }

//     if (forceAspectRatio || props.ratio) {
//         classList.push(`${cssBaseClass}--force-aspect-ratio`);
//         if (props.ratio === "1:1") {
//             heightPercentage = "100%";
//         } else if (props.ratio === "4:3") {
//             heightPercentage = "75%";
//         } else if (props.ratio === "3:2") {
//             heightPercentage = "66.66666666666667%";
//         } else {
//             heightPercentage = "65%";
//         }
//     }

//     if (className) {
//         classList.push(className);
//     }

//     let autoProps;
//     if (props.image) {
//         const src =
//             props.size && props.image.styles
//                 ? props.image.styles[props.size]
//                 : props.image.styles
//                 ? props.image.styles.laptop.href
//                 : "";

//         autoProps = {
//             src: src,
//             alt: props.image.alt,
//         };
//     } else {
//         autoProps = {
//             src: props.src,
//             alt: props.alt,
//         };
//     }

//     return (
//         <div
//             className={classList.join(" ")}
//             style={{
//                 paddingBottom: heightPercentage,
//             }}
//         >
//             {/* Just putting empty alt to keep linter happy - will be overriden by autoProps anyway */}
//             <img alt="" {...autoProps} className={`${cssBaseClass}__image`} />
//         </div>
//     );
// };

// export default Image;

import React from "react";
import { useParallaxController } from "react-scroll-parallax";

const Image = props => {
    const { parallaxController } = useParallaxController();
    return (
        <img
            onLoad={() => {
                parallaxController.update();
            }}
            {...props}
        />
    );
};

export default Image;
